<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="default-page-width">
                <div class="card card-default">
                    <div class="card-header">{{$t('marketing-equipment.' + mode)}}</div>
                    <div class="card-body">
                        <ValidationObserver v-slot="{ invalid }">
                        <form role="form">
                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.type')}} *</label>

                                <div class="col-md-6">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <kendo-dropdownlist ref="fieldconfig"
                                                            :data-items="fieldsDefinitionsDatasource"
                                                            :text-field="'name'"
                                                            :data-item-key="'id'"
                                                            :value-field="'id'"
                                                            :value-primitive="true"
                                                            :value="form.fieldsDefinitionId"
                                                            class="fieldsDefinitionDropDown"
                                                            :default-item="placeholders.fieldsDefinitionsPlaceholderItem"
                                                            @change="onFieldSetDefinitionSelect"
                                        >
                                        </kendo-dropdownlist>
                                        <span>{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.number')}} *</label>

                                <div class="col-md-6">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <input ref="firstInput" type="text" class="form-control" v-model="form.number">
                                        <span>{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.inventorynumber')}}</label>

                                <div class="col-md-6">
                                    <input ref="inventoryNumber" type="text" class="form-control" v-model="form.inventory_number">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.name')}} *</label>

                                <div class="col-md-6">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <input ref="firstInput" type="text" class="form-control" v-model="form.name">
                                        <span>{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.desc')}}</label>

                                <div class="col-md-6">
                                    <input type="text" class="form-control" v-model="form.desc">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.category')}} *</label>

                                <div class="col-md-6">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <kendo-dropdownlist ref="categoryId"
                                                           :data-items="categoryDatasource"
                                                           :text-field="'text'"
                                                           :value-field="'id'"
                                                           :data-item-key="'id'"
                                                           :value-primitive="true"
                                                           v-model="form.categoryId"
                                                           class="fieldsDefinitionDropDown"
                                                           :default-item="placeholders.categoryPlaceholderItem">
                                        </kendo-dropdownlist>
                                        <span>{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.condition')}}</label>

                                <div class="col-md-6">
                                    <input type="text" class="form-control" v-model="form.condition">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.tags')}}</label>

                                <div class="col-md-6">
                                    <kendo-multiselect ref="tagbox"
                                                       :data-items="tagDatasource"
                                                       :text-field="'text'"
                                                       :allow-custom="true"
                                                       :value-field="'value'"
                                                       :data-item-key="'id'"
                                                       :filterable="true"
                                                       :placeholder="$t('general.please_choose_tags')"
                                                       v-model="form.tags"
                                                       @filterchange="onTagboxFilterChange">
                                    </kendo-multiselect>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.images')}}</label>

                                <div class="col-md-6">
                                    <rms-objects-uploads
                                        :mode="mode"
                                        :imageFiles="form.images"
                                        @imageFilesChanged = "onImageFilesChanged"
                                    >
                                    </rms-objects-uploads>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.location')}} *</label>

                                <div class="col-md-6">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <kendo-dropdownlist ref="locationId"
                                                            :data-items="locationDatasource"
                                                            :text-field="'text'"
                                                            :value-field="'id'"
                                                            :data-item-key="'id'"
                                                            :value-primitive="true"
                                                            v-model="form.locationId"
                                                            class="fieldsDefinitionDropDown"
                                                            :default-item="placeholders.locationPlaceholderItem">
                                        </kendo-dropdownlist>
                                        <span>{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.availability')}} *</label>

                                <div class="col-md-6">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <kendo-dropdownlist ref="availabilityId"
                                                            :data-items="availabilityvaluesDatasource"
                                                            :text-field="'text'"
                                                            :value-field="'id'"
                                                            :data-item-key="'id'"
                                                            :value-primitive="true"
                                                            v-model="form.availabilityId"
                                                            class="fieldsDefinitionDropDown"
                                                            :default-item="placeholders.availabilityPlaceholderItem">
                                        </kendo-dropdownlist>
                                        <span>{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>

                            <!-- Service plans (multiple) -->
                            <div class="form-group row" v-if="servicePlansEnabled">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.service-plan')}}</label>
                                <div class="col-md-8">
                                    <!-- Assigned plans list -->
                                    <div v-if="assignedPlans.length > 0" class="mb-2">
                                        <table class="table table-sm">
                                            <thead>
                                            <tr>
                                                <th>{{$t('objects.form.serviceplans.plan')}}</th>
                                                <th>{{$t('objects.grid.next-due')}}</th>
                                                <th style="width:220px">{{$t('objects.form.serviceplans.actions')}}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="ap in assignedPlans" :key="ap.id">
                                                <td>
                                                    {{ap.service_plan?.name}}
                                                    <span v-if="isAssignmentDue(ap)" class="badge badge-danger ml-2">{{$t('objects.grid.service-required')}}</span>
                                                </td>
                                                <td>{{ ap.next_due_at ? formatServiceDate(ap.next_due_at) : '-' }}</td>
                                                <td style="width:280px">
                                                    <div class="d-flex align-items-center">
                                                        <input :type="allowTime ? 'datetime-local' : 'date'" class="form-control form-control-sm mr-1" v-model="ap._override_date" :placeholder="$t('objects.form.first-due-override')"/>
                                                        <button class="btn btn-sm btn-outline-primary mr-1" @click.prevent="overrideAssignment(ap)" :title="$t('objects.form.serviceplans.override-first-due')"><i class="fas fa-calendar-alt"></i></button>
                                                        <button v-if="!ap._isTemp" class="btn btn-sm btn-outline-warning mr-1" @click.prevent="triggerAssignment(ap)" :title="$t('serviceplans.actions.trigger')"><i class="fas fa-bolt"></i></button>
                                                        <button class="btn btn-sm btn-outline-danger" @click.prevent="unassignAssignment(ap)" :title="$t('objects.form.serviceplans.unassign')"><i class="fas fa-trash"></i></button>
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else class="alert alert-secondary p-2">{{$t('objects.form.serviceplans.no-assignments')}}</div>

                                    <!-- Add plan control -->
                                    <div class="card p-2">
                                        <div class="form-row align-items-end">
                                            <div class="form-group col-md-4">
                                                <label>{{$t('objects.form.serviceplans.add-plan')}}</label>
                                                <kendo-dropdownlist ref="addServicePlanId"
                                                                    :data-items="servicePlanDatasource"
                                                                    :text-field="'text'"
                                                                    :value-field="'id'"
                                                                    :data-item-key="'id'"
                                                                    :value-primitive="true"
                                                                    v-model="addPlan.planId"
                                                                    class="fieldsDefinitionDropDown"
                                                                    :disabled="!!addPlan.groupId"
                                                                    :default-item="placeholders.servicePlanPlaceholderItem">
                                                </kendo-dropdownlist>
                                            </div>
                                            <div class="form-group col-md-4">
                                                <label>{{$t('serviceplans.group') || 'Gruppe'}}</label>
                                                <kendo-dropdownlist ref="addServicePlanGroupId"
                                                                    :data-items="servicePlanGroupDatasource"
                                                                    :text-field="'name'"
                                                                    :value-field="'id'"
                                                                    :data-item-key="'id'"
                                                                    :value-primitive="true"
                                                                    v-model="addPlan.groupId"
                                                                    class="fieldsDefinitionDropDown"
                                                                    :disabled="!!addPlan.planId"
                                                                    :default-item="{id: null, name: $t('general.please_choose')}">
                                                </kendo-dropdownlist>
                                            </div>
                                            <div class="form-group col-md-4">
                                                <label>{{$t('objects.form.first-due-override')}}</label>
                                                <input :type="allowTime ? 'datetime-local' : 'date'" class="form-control" v-model="addPlan.first_due_override_at" :disabled="addPlan.first_due_offset_unit && addPlan.first_due_offset_value" />
                                                <small class="form-text text-muted">{{$t('objects.form.first-due-hint')}}</small>
                                            </div>
                                            <div class="form-group col-md-2">
                                                <label>{{$t('objects.form.first-due-offset')}}</label>
                                                <select class="form-control" v-model="addPlan.first_due_offset_unit" :disabled="!!addPlan.first_due_override_at">
                                                    <option :value="null">{{$t('general.please_choose')}}</option>
                                                    <option value="day">{{$t('objects.form.offset-unit.day')}}</option>
                                                    <option value="week">{{$t('objects.form.offset-unit.week')}}</option>
                                                    <option value="month">{{$t('objects.form.offset-unit.month')}}</option>
                                                    <option value="year">{{$t('objects.form.offset-unit.year')}}</option>
                                                </select>
                                            </div>
                                            <div class="form-group col-md-2">
                                                <label>&nbsp;</label>
                                                <input type="number" min="1" class="form-control" v-model.number="addPlan.first_due_offset_value" :disabled="!!addPlan.first_due_override_at" />
                                            </div>
                                            <div class="form-group col-md-12 text-right">
                                                <button class="btn btn-success" @click.prevent="addServicePlan()">{{$t('objects.form.serviceplans.add')}}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Service plan first-due overrides (legacy UI remains hidden for multi-plan) -->
                            <div class="form-group row" v-if="isTimeBasedSelected">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.first-due-override')}}</label>
                                <div class="col-md-6">
                                    <input :type="allowTime ? 'datetime-local' : 'date'" class="form-control" v-model="form.first_due_override_at" :disabled="form.first_due_offset_unit && form.first_due_offset_value" />
                                    <small class="form-text text-muted">{{$t('objects.form.first-due-hint')}}</small>
                                </div>
                            </div>
                            <div class="form-group row" v-if="isTimeBasedSelected">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.first-due-offset')}}</label>
                                <div class="col-md-3">
                                    <select class="form-control" v-model="form.first_due_offset_unit" :disabled="!!form.first_due_override_at">
                                        <option :value="null">{{$t('general.please_choose')}}</option>
                                        <option value="day">{{$t('objects.form.offset-unit.day')}}</option>
                                        <option value="week">{{$t('objects.form.offset-unit.week')}}</option>
                                        <option value="month">{{$t('objects.form.offset-unit.month')}}</option>
                                        <option value="year">{{$t('objects.form.offset-unit.year')}}</option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <input type="number" min="1" class="form-control" v-model.number="form.first_due_offset_value" :disabled="!!form.first_due_override_at" />
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.available-for-rent')}}</label>

                                <div class="col-md-6">
                                    <kendo-switch v-model="form.requestable" />
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.archived')}}</label>

                                <div class="col-md-6">
                                    <kendo-switch v-model="form.archived" />
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.notes')}}</label>

                                <div class="col-md-6">
                                    <kendo-editor ref="noteField"
                                                  :resizable="true"
                                                  :tools="editor.editorTools"
                                                  :default-content="form.note"
                                                  :paste-html="onEditorPasteHtml"
                                                  :content-style="{
                                                    height: '430px',
                                                  }">
                                    </kendo-editor>
                                </div>
                            </div>

                            <div class="form-group row" v-if="convertedFields">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.additional-fields')}}</label>

                                <div class="col-md-6">
                                    <vue-form-generator
                                            :schema="convertedFields"
                                            :model="fieldsDefinitionFilledData"
                                            :options="formOptions"></vue-form-generator>
                                </div>
                            </div>

                            <div class="form-group row mb-0">
                                <div class="col-md-6 offset-md-4">
                                    <div class="btn btn-secondary" v-if="mode == 'create' || mode == 'edit' || mode == 'display'"
                                            @click.prevent="handleBack('objects-grid', true, {reload: false, id: rmsobjectid})">
                                        {{ $t('buttons.back-abort') }}
                                    </div>
                                    <div :disabled="invalid" class="btn btn-success" v-if="mode == 'create'"
                                            v-shortkey.once="['ctrl', 's']" @shortkey="createObject"
                                            @click.prevent="createObject">
                                        {{ $t('buttons.create') }}
                                    </div>
                                    <div :disabled="invalid" class="btn btn-success" v-if="mode == 'edit'"
                                            v-shortkey.once="['ctrl', 's']" @shortkey="editObject"
                                            @click.prevent="editObject">
                                        {{ $t('buttons.save') }}
                                    </div>
                                </div>
                            </div>
                        </form>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import rmsObjectsUploads from "./rms-objects-uploads";

    import { EditorUtils } from "@progress/kendo-vue-editor";
    import { filterBy } from '@progress/kendo-data-query';
    import {$t} from "../../i18Instance";

    export default {
        name: "form-rms-object",
        props: {
            mode: {
                type: String,
                default: 'create'
            },
            user: {
                type: String
            },
            rmsobjectid: {
                type: Number
            },
            formdisabled: {
                type: Boolean,
                default: false
            }
        },
        components:{
            rmsObjectsUploads
        },
        computed: {
            servicePlansEnabled(){
                return typeof window !== 'undefined' ? !!window.__servicePlansEnabled : true;
            },
            allowTime(){
                return typeof window !== 'undefined' ? !!window.__servicePlansAllowTime : false;
            },
            selectedPlan() {
                if (!this.form.servicePlanId) return null;
                return this.servicePlanDatasource.find(p => p.id === this.form.servicePlanId) || null;
            },
            isTimeBasedSelected() {
                const p = this.selectedPlan;
                return !!(p && p.trigger_time_unit && p.trigger_time_value);
            }
        },
        data: function () {
            return {
                fieldsDefinitionsDatasource: [],
                categoryDatasource: [],
                tagDatasource: [],
                tagDatasourceUnfiltered: [],
                locationDatasource: [],
                availabilityvaluesDatasource: [],
                servicePlanDatasource: [],
                servicePlanGroupDatasource: [],
                // Multi-plan support
                assignedPlans: [],
                // queued ops to apply on save (create or update)
                planOps: {
                    add: [], // { service_plan_id, service_plan_group_id?, first_due_override_at?, first_due_offset_unit?, first_due_offset_value? }
                    override: [], // { assignment_id, first_due_override_at?, first_due_offset_unit?, first_due_offset_value? }
                    unassign: [] // { assignment_id }
                },
                addPlan: {
                    planId: null,
                    groupId: null,
                    first_due_override_at: null,
                    first_due_offset_unit: null,
                    first_due_offset_value: null,
                },

                loadedData: false,
                blankItem: {
                    id: null,
                    name: this.$t('general.please_choose')
                },
                form:{
                    fieldsDefinitionId: null,
                    categoryId: null,
                    locationId: null,
                    availabilityId: null,
                    servicePlanId: null,
                    first_due_override_at: null,
                    first_due_offset_unit: null,
                    first_due_offset_value: null,
                    requestable: false,
                    archived: false,
                    note: "",
                    mainImage: null,
                    tags: null,
                    image: {}
                },
                formOptions: {
                    validateAfterLoad: false,
                    validateAsync: true,
                    validateAfterChanged: true,
                    validationErrorClass: "error",
                    validationSuccessClass: ""
                },
                fieldsDefinition:{
                    field_type: null,
                },
                fieldsDefinitionFilledData: {},
                convertedFields:null,


                editor:{
                    editorTools: [
                        "FormatBlock",
                        "FontSize",
                        "FontName",
                        ["Bold", "Italic", "Underline", "Strikethrough"],
                        ["AlignLeft", "AlignCenter", "AlignRight"],
                        ["Indent", "Outdent"],
                        ["OrderedList", "UnorderedList"],
                        ["Undo", "Redo"],
                        ["Link", "Unlink", "InsertImage"],
                    ],
                },

                placeholders:{
                    fieldsDefinitionsPlaceholderItem:{
                        name: this.$t('general.please_choose')
                    },
                    categoryPlaceholderItem: {
                        text: this.$t('objects.form.please_choose_category')
                    },
                    locationPlaceholderItem: {
                        text: this.$t('objects.form.please_choose_location')
                    },
                    availabilityPlaceholderItem: {
                        text: this.$t('objects.form.please_choose_availability')
                    },
                    servicePlanPlaceholderItem: {
                        text: this.$t('objects.form.please_choose_serviceplan')
                    }

                }

            }
        },
        mounted() {
            this.init();
        },
        methods: {
            formatServiceDate(val){
                if(!val) return '-';
                const s = String(val);
                const allowTime = this.allowTime;
                if(!allowTime){
                    // show date only (YYYY-MM-DD)
                    if(s.includes('T')) return s.substring(0,10);
                    if(s.includes(' ')) return s.substring(0,10);
                    return s;
                }
                // prefer raw without timezone conversion
                if(s.includes('T')) return s.replace('T',' ').substring(0,16);
                return s.substring(0,16);
            },
            toInputDate(val){
                if(!val) return null;
                const s = String(val);
                if(this.allowTime){
                    // Expect format YYYY-MM-DDTHH:mm for datetime-local
                    if(s.includes(' ')){
                        // convert "YYYY-MM-DD HH:mm:ss" => "YYYY-MM-DDTHH:mm"
                        return s.substring(0,16).replace(' ', 'T');
                    }
                    if(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(s)){
                        return s.substring(0,16);
                    }
                    if(/^\d{4}-\d{2}-\d{2}$/.test(s)){
                        return s + 'T00:00';
                    }
                    return s;
                } else {
                    // date-only input expects YYYY-MM-DD
                    if(s.includes('T') || s.includes(' ')){
                        return s.substring(0,10);
                    }
                    return s;
                }
            },
            normalizeDateForApi(input){
                if(!input) return null;
                const s = String(input);
                // if date-only (YYYY-MM-DD), append 00:00:00
                if(/^\d{4}-\d{2}-\d{2}$/.test(s)){
                    return s + ' 00:00:00';
                }
                return s;
            },
            onImageFilesChanged(changedMedia){
                this.form.imageFiles = changedMedia;
            },

            // Alternative Methode, um einen Tag durch "Return" hinzuzufügen"
            init(){

                // Laden der Felddefinitionen
                axios
                    .get('/api/rmsobjects/fieldsdefinitions')
                    .then(response => {
                        this.fieldsDefinitionsDatasource = response.data;
                    });

                // Laden der Kategorien
                axios
                    .get('/api/rmsobjects/categories')
                    .then(response => {
                        this.categoryDatasource = response.data;
                    });

                // Laden der Tags
                axios
                    .get('/api/rmsobjects/tags')
                    .then(response => {
                        this.tagDatasource = response.data;
                        this.tagDatasourceUnfiltered = response.data;
                    });

                // Laden der Standorte
                axios
                    .get('/api/rmsobjects/locations')
                    .then(response => {
                        this.locationDatasource = response.data;
                    });

                // Laden der Verfügbarkeiten
                axios
                    .get('/api/rmsobjects/availabilityvalues')
                    .then(response => {
                        this.availabilityvaluesDatasource = response.data;
                    });

                // Servicepläne (für Dropdown)
                axios
                    .get('/api/service-plans')
                    .then(response => {
                        // Controller liefert { data: [...] }
                        this.servicePlanDatasource = response.data && response.data.data ? response.data.data : [];
                    });

                // Serviceplangruppen (für Dropdown)
                axios
                    .get('/api/service-plan-groups')
                    .then(response => {
                        this.servicePlanGroupDatasource = response.data && response.data.data ? response.data.data : [];
                    });

                // Laden eines bestehenden Objektes
                if(this.rmsobjectid){
                        this.mode = "edit";
                    axios
                        .get('/api/rmsobjects/id/' + this.rmsobjectid)
                        .then(response => {
                            console.log("got data", response);
                            this.loadedData = response.data;
                            this.prepareEditData();
                        })
                        .catch(error => {
                            console.log("err", error);
                        })
                        .finally(() => {})
                }else{
                    this.mode = "create";
                }



            },

            /**
             * Bereitet die geladenen Daten für die Edit-Maske vor
             */
            prepareEditData: function() {
                console.log("prepareEditData");
                // Formulardaten setzen
                //console.log(this.loadedData);
                this.form.id = this.loadedData.id;
                this.form.fieldsDefinitionId = this.loadedData.field_set_definition_id;
                this.form.number = this.loadedData.number;
                this.form.inventory_number = this.loadedData.inventory_number;
                this.form.name = this.loadedData.name;
                this.form.desc = this.loadedData.desc;
                this.form.categoryId = this.loadedData.category_id;
                this.form.condition = this.loadedData.condition;
                this.form.tags = this.loadedData.attachedTags;
                this.form.images =this.loadedData.images;
                this.form.locationId = this.loadedData.location_id;
                this.form.availabilityId = this.loadedData.availability_id;
                this.form.requestable = this.loadedData.requestable;
                if(this.loadedData['archived_at'] && this.loadedData['archived_at'] != 'null' && this.loadedData['archived_at'] != undefined){
                    this.form.archived = true;
                }else{
                    this.form.archived = false;
                }
                if(this.loadedData.note){
                    this.$refs['noteField'].setHTML(this.loadedData.note);
                }


                // Zusätzliche Felder
                this.loadFieldSetDefinition(null, this.form.fieldsDefinitionId);
                this.fieldsDefinitionFilledData = this.loadedData.form_data;
                if(null == this.fieldsDefinitionFilledData || this.fieldsDefinitionFilledData.length == 0){
                    this.fieldsDefinitionFilledData = {};
                }

                // Aktuelle Serviceplan-Assignments laden (multi-plan)
                this.loadAssignedPlans();
            },

            // region FieldsetDefinitions

            /**
             * Eventhandler wird ausgelöst, wenn die Auswahl der Formularfelddefinition geändert wurde
             * @param e
             */
            onFieldSetDefinitionSelect(e){
                console.log("changed selection: ", e.value);
                console.log("old value: ", this.form.fieldsDefinitionId);
                // Standarfverhalten auf jeden Fall abbrechen und manuell die Werte setzen
                //e.preventDefault();
                //this.confirmSelectionChange(e, e.dataItem.id, e.sender.value());
                this.confirmSelectionChange(e, e.value, this.form.fieldsDefinitionId);
            },

            /**
             * Bestätigt die
             * @param e
             */
            confirmSelectionChange(e, definitionId, oldId){
                console.log("select", e, definitionId, oldId);
                if(!_.isEmpty(this.fieldsDefinitionFilledData) && (this.form.fieldsDefinitionId != definitionId || definitionId <= 0)){
                    // Wenn wieder auf "Bitte wählen" geschaltet wird Daten zurücksetzen. (ggf. Warnung)
                    swal.fire({
                        title: this.$t('objects.form.additional-fields-exit-header'),
                        text: this.$t('objects.form.additional-fields-exit-text'),
                        icon: "warning",
                        showCancelButton: true,
                        cancelButtonText: this.$t('general.cancel'),
                        confirmButtonText: this.$t('general.ok')
                    }).then((willDelete) => {
                            if (willDelete.value) {
                                // Felddefinition wechseln
                                this.fieldsDefinitionFilledData = {};
                                this.convertedFields=null;
                                this.loadFieldSetDefinition(e, definitionId);
                            } else {
                                return;
                            }
                        });
                }else{
                    console.log("normales laden der Felddefinition");
                    this.convertedFields=null;
                    this.form.fieldsDefinitionId = definitionId;
                    this.loadFieldSetDefinition(e, definitionId);
                }
            },

            /**
             * Lädt die Formularfelddefinition
             * @param definitionId
             */
            loadFieldSetDefinition(e, definitionId){
                console.log("loadfieldsetdefinition?", e, definitionId);
                this.form.fieldsDefinitionId = definitionId;
                if(definitionId !== "" && definitionId !== null && definitionId !== undefined){
                    axios.get('/api/rmsobjects/fieldsdefinitions/id/' + definitionId)
                        .then(response => {
                            console.log("loadfieldsetdefinition response", response);
                            this.fieldsDefinition = response.data;
                            this.buildForm(this.fieldsDefinition);
                        });
                }
            },

            /**
             * Baut das Formular unter Verwendung der übergebenen Felddefinition auf
             * @param fieldsDefinition Formularfelddefinition
             */
            buildForm(fieldsDefinition){
                console.log("building form");
                let tmpArr = {fields:[]};
                fieldsDefinition.field_type.map(function(value, key) {
                    if(value.configuration.label){
                        value.configuration.label = $t('cstrings.colfields.' + value.configuration.label);
                    }
                    if(value.configuration.placeholder){
                        value.configuration.placeholder = $t('cstrings.colfields.' + value.configuration.placeholder);
                    }
                    if(value.configuration.hint){
                        value.configuration.hint = $t('cstrings.colfields.' + value.configuration.hint);
                    }

                    tmpArr.fields.push(value.configuration)
                });
                this.convertedFields = tmpArr;
            },

            //endregion


            // region Tag-Box

            onTagboxFilterChange(e){
                this.tagDatasource = filterBy(this.tagDatasourceUnfiltered.slice(), e.filter);
            },

            onEditorPasteHtml(e) {
                let html = pasteCleanup(sanitize(e.pastedHtml), pasteSettings);
                if (e.event.clipboardData) {
                    html = replaceImageSourcesFromRtf(html, e.event.clipboardData);
                }
                return html;
            },

            //endregion

            resetForm(){
                this.form = {};
            },

            onWindowActivated(){
                this.$refs.firstInput.focus();
            },

            onWindowClosed:function(){
                this.resetForm();
            },

            /**
             * Bereitet Daten zum senden vor
             */
            prepareData(){
                this.form.customFields = this.fieldsDefinitionFilledData;
                this.form.note = this.$refs['noteField'].getHTML();
                // attach queued service plan operations to be applied server-side on save
                this.form.servicePlanOps = this.planOps;

                console.log(this.form);
            },

            createObject() {
                this.prepareData();
                this.sendForm('post','/api/rmsobjects', this.form)
                    .then(() => {
                        console.log("angelegt");
                        this.resetForm();
                        this.$emit('rms-object-created');
                        //this.hideWindow();
                        swal.fire({
                            title: this.$t("objects.created.popup.title"),
                            text: this.$t("objects.created.popup.text"),
                            icon: "success",
                            timer: 1000
                        }).then(() => {
                            this.handleBack('objects-grid', true, {reload: true});
                        });
                    });
            },


            editObject(){
                this.prepareData();
                this.sendForm('put','/api/rmsobjects/update/'+this.form.id, this.form)
                    .then(() => {
                        this.$emit('rms-object-updated');
                        swal.fire({
                            title: this.$t("objects.updated.popup.title"),
                            text: this.$t("objects.updated.popup.text"),
                            icon: "success",
                            timer: 1000
                        }).then(() => {
                            this.handleBack('objects-grid', true, {reload: true, id: this.form.id});
                        });
                    });
            },

            // Multi-plan helpers
            async loadAssignedPlans(){
                if(!this.form.id) return;
                try{
                    const { data } = await axios.get(`/api/rmsobjects/${this.form.id}/service-plans`);
                    this.assignedPlans = (data && data.data) ? data.data.map(x => ({
                        ...x,
                        // prefill override input with existing first_due_override_at
                        _override_date: this.toInputDate(x.first_due_override_at)
                    })) : [];
                }catch(e){ console.error(e); this.assignedPlans = []; }
            },
            isAssignmentDue(ap){
                const now = new Date();
                const next = ap && ap.next_due_at ? new Date(String(ap.next_due_at).replace(' ', 'T')) : null;
                const required = ap && ap.service_required_at ? new Date(String(ap.service_required_at).replace(' ', 'T')) : null;
                if(required && required <= now) return true;
                if(next && next <= now) return true;
                return false;
            },

            async addServicePlan(){
                try{
                    if(!this.addPlan.planId && !this.addPlan.groupId){
                        await swal.fire({ title: this.$t('general.warning'), text: this.$t('objects.form.please_choose_serviceplan'), icon: 'warning' });
                        return;
                    }

                    // Handle single plan
                    if (this.addPlan.planId) {
                        // Prevent adding the same plan multiple times in the UI before save
                        const alreadyAssigned = this.assignedPlans.some(x => x?.service_plan?.id === this.addPlan.planId);
                        const alreadyQueued = this.planOps.add.some(x => x.service_plan_id === this.addPlan.planId);
                        if (alreadyAssigned || alreadyQueued) {
                            await swal.fire({
                                title: this.$t('objects.form.serviceplans.already-added-title') || this.$t('general.warning'),
                                text: this.$t('objects.form.serviceplans.already-added-text') || 'This service plan is already added.',
                                icon: 'warning'
                            });
                            return;
                        }
                    }

                    const hasOverrideDate = !!this.addPlan.first_due_override_at;
                    const hasOverrideOffset = !!(this.addPlan.first_due_offset_unit && this.addPlan.first_due_offset_value);
                    if (hasOverrideDate && hasOverrideOffset) {
                        await swal.fire({ title: this.$t('general.warning'), text: this.$t('objects.form.first-due-both-error'), icon: 'warning' });
                        return;
                    }
                    if (hasOverrideOffset) {
                        const v = Number(this.addPlan.first_due_offset_value);
                        if (!Number.isInteger(v) || v <= 0) {
                            await swal.fire({ title: this.$t('general.warning'), text: this.$t('objects.form.first-due-offset-invalid'), icon: 'warning' });
                            return;
                        }
                    }

                    const payload = {
                        service_plan_id: this.addPlan.planId,
                        service_plan_group_id: this.addPlan.groupId
                    };
                    if (hasOverrideDate){
                        payload.first_due_override_at = this.normalizeDateForApi(this.addPlan.first_due_override_at);
                    } else if (hasOverrideOffset){
                        payload.first_due_offset_unit = this.addPlan.first_due_offset_unit;
                        payload.first_due_offset_value = this.addPlan.first_due_offset_value;
                    }
                    // queue operation; will be applied on save
                    this.planOps.add.push(payload);

                    // update local preview list (assignedPlans)
                    if (this.addPlan.planId) {
                        const planInfo = this.servicePlanDatasource.find(p => p.id === this.addPlan.planId) || { id: this.addPlan.planId, name: '', text: '' };
                        this.assignedPlans.push({
                            id: 'tmp_'+Date.now()+Math.random(), // temp id for UI
                            service_plan: { id: planInfo.id, name: planInfo.name || planInfo.text },
                            next_due_at: null,
                            service_required_at: null,
                            _override_date: hasOverrideDate ? this.addPlan.first_due_override_at : null,
                            _isTemp: true
                        });
                    } else if (this.addPlan.groupId) {
                        const groupInfo = this.servicePlanGroupDatasource.find(g => g.id === this.addPlan.groupId);
                        if (groupInfo && groupInfo.service_plans) {
                            groupInfo.service_plans.forEach(p => {
                                // Only add if not already assigned or queued
                                const alreadyAssigned = this.assignedPlans.some(x => x?.service_plan?.id === p.id);
                                const alreadyQueued = this.planOps.add.some(x => x.service_plan_id === p.id);
                                if (!alreadyAssigned && !alreadyQueued) {
                                    this.assignedPlans.push({
                                        id: 'tmp_'+Date.now()+Math.random(), // temp id for UI
                                        service_plan: { id: p.id, name: p.name },
                                        next_due_at: null,
                                        service_required_at: null,
                                        _override_date: hasOverrideDate ? this.addPlan.first_due_override_at : null,
                                        _isTemp: true
                                    });
                                }
                            });
                        }
                    }

                    // reset add form
                    this.addPlan = { planId: null, groupId: null, first_due_override_at: null, first_due_offset_unit: null, first_due_offset_value: null };
                    // Do not show a success message here; the plan is only queued and will be saved with the object
                }catch(e){ console.error(e); swal.fire({ icon:'error', text: (e.response && e.response.data && e.response.data.message) || 'Error' }); }
            },

            async overrideAssignment(ap){
                try{
                    if(!ap) return;
                    const payload = { assignment_id: ap.id, first_due_override_at: this.normalizeDateForApi(ap._override_date) || null };
                    this.planOps.override.push(payload);
                    // reflect in UI only
                    ap._pending_override = true;
                    swal.fire({ icon: 'success', title: this.$t('general.saved'), text: this.$t('buttons.save') + ' – ' + this.$t('objects.updated.popup.text'), timer: 1200 });
                }catch(e){ console.error(e); swal.fire({ icon:'error', text: (e.response && e.response.data && e.response.data.message) || 'Error' }); }
            },

            async triggerAssignment(ap) {
                try {
                    if (!ap || ap._isTemp) return;
                    const ok = await swal.fire({
                        title: ap.service_plan?.name,
                        text: (this.$t('serviceplans.actions.trigger_confirm') || 'Möchten Sie diesen Serviceplan jetzt fällig stellen?') + '?',
                        icon: 'warning',
                        showCancelButton: true
                    });
                    if (!ok.value) return;

                    await axios.post(`/api/rmsobjects/${this.form.id}/service-plan/${ap.id}/trigger`);
                    await swal.fire({ icon: 'success', title: this.$t('general.saved') || 'Gespeichert', timer: 900 });

                    // Reload assigned plans to show updated status/dates
                    await this.loadAssignedPlans();
                } catch (e) {
                    console.error(e);
                    swal.fire({ icon: 'error', text: (e.response && e.response.data && e.response.data.message) || 'Error' });
                }
            },

            async unassignAssignment(ap){
                try{
                    if(!ap) return;
                    const ok = await swal.fire({ title: this.$t('general.are_you_sure') || 'Are you sure?', text: this.$t('general.cannot_be_undone') || 'Cannot be undone', icon: 'warning', showCancelButton: true });
                    if(!ok.value) return;
                    // queue unassign
                    this.planOps.unassign.push({ assignment_id: ap.id });
                    // update local UI: remove row if it is an existing one, or filter temp
                    this.assignedPlans = this.assignedPlans.filter(x => x.id !== ap.id);
                    swal.fire({ icon:'success', title: this.$t('general.deleted'), timer: 700 });
                }catch(e){ console.error(e); swal.fire({ icon:'error', text: (e.response && e.response.data && e.response.data.message) || 'Error' }); }
            },

            onSaveFile:function(e){
                console.log("onSaveFile",e);
                var xhr = e.XMLHttpRequest;
                console.log("xhr",xhr);
                if (xhr) {
                    xhr.addEventListener("readystatechange", function (e) {
                        if (xhr.readyState == 1 /* OPENED */) {
                            xhr.setRequestHeader("X-CSRF-TOKEN", $('meta[name="csrf-token"]').attr('content'));
                            xhr.setRequestHeader("X-XSRF-TOKEN", $('meta[name="xsrf-token"]').attr('content'));
                        }
                    });
                }
            },

            onSaveFileSuccess:function(e){
                console.log("Save File success:",e);
                if(e.response.error == 0){
                    this.form.tmpFile = e.response;
                }
            },

            onSaveFileComplete:function(e){
                console.log("Save File complete:",e);
            },

            onSaveFileError:function(e){
                console.log("Save File Error:",e);
            },

            sendForm(method, uri, form){
                return new Promise((resolve, reject) => {
                    axios[method](uri, JSON.parse(JSON.stringify(form)))
                        .then(response => {
                            resolve(response.data);
                        })
                        .catch(errors => {
                            reject(errors.response.data);
                        });
                });
            }
        }
    }
</script>

<style scoped>
</style>
